import React from "react";
import { Col, Container, Row } from "reactstrap";
import styles from "../styles/AboutPageStyle.module.css";
import ExportedShipping from "./../assets/imgs/ExportShipping.jpg";
import Ship from "../assets/imgs/EF Branding Website/aerial-view-container-cargo-ship-sea.jpg";
import Shelf from "../assets/imgs/EF Branding Website/distribution-warehouse-building-interior-large-storage-area-with-goods-shelf.jpg";
import Strength from "../assets/imgs/EF Branding Website/strength-people-hands-success-meeting.jpg";
import Man from "../assets/imgs/EF Branding Website/handsome-young-man-working-with-papers.jpg";
import Woman from "../assets/imgs/EF Branding Website/beautiful-smart-asian-young-entrepreneur-business-woman-owner-sme-online-checking-product (4).jpg";
import Global from "../assets/imgs/EF Branding Website/240_F_443956484_YbGZYCLvZC0f6v2kBpNLGjpO87fCm7SI.jpg";
const AboutPage = () => {
  return (
    <div>
      <Container className={styles.about_us_container}>
        <Row>
          <Row className="py-5 mb-5">
            <Col md={6} className={styles.about_us}>
              <h5 className="fw-bold">About Us</h5>
              <p>
                Easyf is an international logistics company. We have experience
                in handling the formalities and documentation required for your
                imports and exports. We work with all international station to
                guarantee that your load will safely reach without any delays.
              </p>
              <p>
                We provides one-stop custom solutions for all your supply chain
                logistics needs from the supplier to the final receiver via
                global ocean freight shipping.
              </p>
              <p>
                Easyf has experience in handling the formalities and
                documentation required for your imports and exports. We work
                with international station to guarantee that your load will
                safely reach without any delays.
              </p>
            </Col>
            <Col md={6} className="my-sm-5">
              <div className="d-flex justify-content-end position-relative ">
                <img src={Ship} className={styles.absolute_img} />
                <div className={styles.about_us_img}>
                  <img src={Shelf} className={styles.absolute_img} />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="py-5 justify-content-center ms-1">
            <h5 className="text-center fw-bold mt-5">Mission</h5>
            <Row className="py-5 py-sm-0 d-flex mb-3 mt-5 justify-content-sm-center">
              <Col className="d-flex justify-content-center align-items-center position-relative">
                <div className={styles.background}></div>
                <img src={Strength} className={styles.about_img_second} />
              </Col>
              <Col className="d-flex justify-content-end align-items-center">
                <p
                  className={styles.padding_one}
                  // style={{ paddingLeft: "12%" }}
                >
                  Achieve goals with confidence and assertiveness.
                </p>
              </Col>
            </Row>
            <Row className="py-5 d-flex mb-3 justify-content-sm-center flex-column-reverse flex-lg-row flex-md-row">
              <Col className="d-flex justify-content-left align-items-center ">
                <p
                  className={styles.padding_one}
                  // style={{ paddingLeft: "12%" }}
                >
                  Our experiences , service quality and innovation to each and
                  all of our clients
                </p>
              </Col>
              <Col className="d-flex justify-content-center align-items-center position-relative">
                <div className={styles.background_right}></div>
                <img src={Woman} className={styles.about_img_second} />
              </Col>
            </Row>
            <Row className="py-5 py-sm-0 d-flex mb-3 justify-content-sm-center">
              <Col className="d-flex justify-content-center align-items-center position-relative">
                <div className={styles.background}></div>
                <img src={Man} className={styles.about_img_second} />
              </Col>
              <Col className="d-flex justify-content-center align-items-center">
                <p
                  className={styles.padding_two}
                  // className="fw-bold text-center"
                  // style={{ paddingRight: "8%" }}
                >
                  Applying and offering the exceptional value in the market and
                  setting the standard for professionalism in the logistics
                  society.
                </p>
              </Col>
            </Row>
            <Row className="py-5 py-sm-0 d-flex mb-3 justify-content-sm-center flex-column-reverse flex-lg-row flex-md-row">
              <Col className="d-flex justify-content-center align-items-center ">
                <p
                  className={styles.padding_three}
                  // className="fw-bold text-center"
                  // style={{ paddingLeft: "10%" }}
                >
                  Our goal is to provide a safe, secure work environment and
                  reach out many countries in Asia.
                </p>
              </Col>
              <Col className="d-flex justify-content-center align-items-center position-relative">
                <div className={styles.background_right}></div>
                <img src={Global} className={styles.about_img_second} />
              </Col>
            </Row>
          </Row>
        </Row>
      </Container>
      <Container fluid>
        <Row className={styles.vision}>
          <h5 className="mb-5">Vision</h5>
          <p>
            To be recognized as the most grounded worldwide and competitive
            logistics services as a trusted partner to all of our clients , to
            keep our success and make more increase customer loyalty.
          </p>
        </Row>
        <Row className="py-5">
          <h5 className="text-center fw-bold mb-lg-5">Our Values</h5>
          <div className="d-flex flex-wrap mt-5 justify-content-center justify-content-lg-start">
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative me-2 me-lg-0 me-md-0"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>Safety</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>Trust</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative me-2 me-lg-0 me-md-0"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>Creativity</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>Accountability</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative me-2 me-lg-0 me-md-0"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>Teamwork</div>
            </Col>
            <Col
              md={2}
              className="d-flex justify-content-center py-5 py-sm-0 position-relative"
            >
              <div className={styles.values_background}></div>
              <div className={styles.values}>
                <div className="d-flex flex-column text-center">
                  <span>Service</span>
                  <span>Leadership</span>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </Container>{" "}
    </div>
  );
};
export default AboutPage;
